import React, { Children } from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    ChevronWrapper,
    CollapseChildren,
    CollapseLabel,
    CollapseWrapper,
    SectionTitle,
} from 'src/ui/components/collapse/sports/03/Collapse.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface CollapsePropsType {
    children?: React.ReactNode;
    className?: string;
    dataTest?: string;
    handleToggle: () => void;
    isOpen: boolean;
    title: React.ReactNode;
}

/**
 * This component will be used for sections:
 * - **US Sports**
 * - **HR and GR**
 */
export const Collapse = observer(
    'Collapse',

    ({ children, className, dataTest, handleToggle, isOpen, title }: CollapsePropsType): JSX.Element => {
        const hasChildren = Children.count(children) > 0;
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;

        return (
            <CollapseWrapper
                data-test={dataTest}
                isOpen={isOpen}
                onClick={handleToggle}
                className={className}
                variant={configState.componentVariants.collapseVariant}
            >
                <CollapseLabel>
                    <ChevronWrapper position={isOpen ? 'up' : 'right'} />
                    <SectionTitle data-test='section-title'>{title}</SectionTitle>
                </CollapseLabel>

                {hasChildren && <CollapseChildren>{children}</CollapseChildren>}
            </CollapseWrapper>
        );
    }
);
